/// <reference types="vite/client" />

import { isTestEnv } from "./envs.shared.ts";

declare const window: { location: { hostname: string } };

export const isLocal = (): boolean => import.meta.env.DEV || window.location.hostname === "localhost";

export const isPreview = (): boolean => import.meta.env.MODE === "preview";
export const isProd = (): boolean => import.meta.env.MODE === "production";

export const isProdOrPreviewEnv = (): boolean => isProd() || isPreview();

export { isTestEnv };

export const getEnvironment = () => {
  if (isProd()) {
    return "production";
  }
  if (isPreview()) {
    return "preview";
  }
  if (isTestEnv()) {
    return "test";
  }
  if (isLocal()) {
    return "local";
  }
  return "Unknown environment";
};
